import isUUID from 'is-uuid';

export default isUUID.anyNonNil;
